import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Table } from "antd";
import { IconTableSolidFull } from "../../../icon";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { useSelector } from "react-redux";

const reports = [
  {
    name: "Kunden",
    url: "/api/plamo/report/customers"
  },
  {
    name: "Mitarbeitende",
    url: "/api/plamo/report/employees"
  }
]

function ReportsPage() {
  const navigate = useNavigate()
  const userToken = useSelector(state => (state as any).user?.userToken);

  const onClickReport = useCallback(async (link, filename) => {
    const response = await fetch(link, { method: 'GET', headers: { 'Authorization': `Bearer ${userToken}` } });
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a") as any;
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }, [userToken])
  
  return <div>
    <Breadcrumb
          style={{ marginBottom: "24px" }}
          items={[
            {
              onClick: () => navigate('/'),
              title: <HomeOutlined/>,
            },
            {
              title: (
                <>
                  <IconTableSolidFull />
                  <span>Auswertungen</span>
                </>
              ),
            },         
          ]}
        />
    
    <Table
      columns={[
        {
          dataIndex: "name",
          title: "Auswertung",
          render: (_, record) => <Button type="link" onClick={() => onClickReport(record.url, `${record.name}.xlsx`)}>{ record.name }</Button>
        }
      ]}
      dataSource={reports}
      pagination={false}
    />
    </div>
}

export default ReportsPage;